import { useState } from "react";
import { faqItems } from "@/mocks/faq";
import StructuredData from "@/components/feature/StructuredData";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqItems.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  };

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <StructuredData data={faqSchema} />
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2
            className="text-2xl md:text-4xl font-bold text-foreground-950 mb-3"
            style={{ fontFamily: "var(--font-heading)" }}
          >
            常见问题解答
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            关于P站视频的常见疑问，这里有详细解答
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left"
              >
                <h4 className="text-sm md:text-base font-medium text-foreground-950 pr-4">
                  {item.question}
                </h4>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-400 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? "rotate-180" : ""
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
                }`}
              >
                <p className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}